import { render } from "./ReceivedPacket.vue?vue&type=template&id=3e3b5a38"
import script from "./ReceivedPacket.vue?vue&type=script&lang=js"
export * from "./ReceivedPacket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__